import React, { useState } from 'react'
import { ScoreRadar, ScoreRadarModal } from '@popety-io/ui'
import { getScoreColor } from '@popety-io/utils'
import type { PublicLandAnalysis } from '@popety-io/types'
import {
  HeaderContainer,
  HeaderContent,
  PropertyInfo,
  RadarContainer,
  PropertyDetails,
  PropertyTitle,
  PropertyMeta,
  MetaItem,
  MetaDivider,
} from './PublicLandAnalysisHeader.styles'

export interface PublicLandAnalysisHeaderProps {
  propertyId: string
  propertyTitle: string
  propertyAddress: string
  zone: string
  area: string
  reference: string
  land: PublicLandAnalysis
}

export const PublicLandAnalysisHeader: React.FC<
  PublicLandAnalysisHeaderProps
> = ({ propertyTitle, propertyAddress, zone, area, reference, land }) => {
  const [isScoreModalOpen, setIsScoreModalOpen] = useState(false)

  return (
    <HeaderContainer>
      <HeaderContent>
        <PropertyInfo>
          <RadarContainer>
            {land && (
              <>
                <ScoreRadar
                  property={land}
                  size={80}
                  getScoreColor={getScoreColor}
                  onClick={() => setIsScoreModalOpen(true)}
                />
                <ScoreRadarModal
                  isOpen={isScoreModalOpen}
                  onClose={() => setIsScoreModalOpen(false)}
                  property={land}
                  getScoreColor={getScoreColor}
                />
              </>
            )}
          </RadarContainer>

          <PropertyDetails>
            <PropertyTitle>{propertyTitle}</PropertyTitle>
            <PropertyMeta>
              <MetaItem>{propertyAddress}</MetaItem>
              <MetaDivider />
              <MetaItem>{zone}</MetaItem>
              <MetaDivider />
              <MetaItem>{area}</MetaItem>
              <MetaDivider />
              <MetaItem>{reference}</MetaItem>
            </PropertyMeta>
          </PropertyDetails>
        </PropertyInfo>
      </HeaderContent>
    </HeaderContainer>
  )
}
